/* eslint-disable camelcase */
let isPublicPathFixed = false

export default function fixPublicPath(staticHost = '') {
  if (!isPublicPathFixed && typeof __webpack_public_path__ !== 'undefined') {
    __webpack_public_path__ = staticHost + __webpack_public_path__
    isPublicPathFixed = true
  }
}
